// @flow
import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';

import {
  Introduction,
  type IntroductionProps,
} from 'Components/frameworks/introduction/Introduction.jsx';
import { Tabs, type TabsItem } from 'Components/frameworks/tabs/Tabs.jsx';

type ProductInformationProps = {
  introduction?: IntroductionProps,
  items: Array<$Shape<TabsItem>>,
  scrollBackwardLabel?: string,
  scrollForwardLabel?: string,
};

export function ProductInformation(props: ProductInformationProps) {
  const { introduction, items, scrollBackwardLabel, scrollForwardLabel } = props;

  return (
    <Fragment>
      {!isEmpty(introduction) && <Introduction className="mb-4" {...introduction} />}
      <Tabs
        isContentUnmountedOnCollapse
        isScrollable
        items={items}
        scrollBackwardLabel={scrollBackwardLabel}
        scrollForwardLabel={scrollForwardLabel}
        theme="lite"
      />
    </Fragment>
  );
}
